import axiosClient from ".";

class DashboardAPI {
  static getDashboardStat() {
    return axiosClient.get("super_admin/api/dashboards.json");
  }
}
export default DashboardAPI;
